const _Hub_Name = "CallLogHub";

const _Invoke_Methods_Names = {
  SaveCallLog: "SaveCallLog",
};

const _OnReceive_Methods_Names = {
  onSaveCallLog: "SaveCallLogResponse",
};

const Voice_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Voice_signalr;
